import _defineProperty from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _classCallCheck from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var ReducerUUID = 0;
export var ReducerBuilderProgress =
/*#__PURE__*/
function () {
  function ReducerBuilderProgress(initialState, reactotronKey) {
    var _this = this;

    _classCallCheck(this, ReducerBuilderProgress);

    this.buildsMap = _defineProperty({}, ReducerBuilder.EVENT_ACTION_RESET_ALL_REDUCERS_TO_INITIAL_STATE.type, function () {
      return _this.initialState;
    });

    this.buildStateToProps = function (propGroupName) {
      return _this.createStateObject(propGroupName);
    };

    this.createStateObject = function (propGroupName) {
      return function (state) {
        if (!state[_this.reactotronKey]) console.error("Reducer not registered in CombinedReducers");

        var stateObject = _defineProperty({}, propGroupName, {});

        Object.keys(_this.initialState).forEach(function (key) {
          propGroupName ? stateObject[propGroupName][key] = state[_this.reactotronKey][key] : stateObject[key] = state[_this.reactotronKey][key];
        });
        stateObject.reactotronKey = _this.reactotronKey;
        return stateObject;
      };
    };

    this.initialState = initialState;
    this.reactotronKey = reactotronKey;
  }

  _createClass(ReducerBuilderProgress, [{
    key: "onEvent",
    value: function onEvent(typeObj, newState) {
      if (!typeObj) console.warn("Reducer event is null");else this.buildsMap[typeObj.type] = newState;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      var _this2 = this;

      var funcReturn = function funcReturn() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.initialState;
        var payload = arguments.length > 1 ? arguments[1] : undefined;
        if (_this2.buildsMap.hasOwnProperty(payload.type)) return _this2.buildsMap[payload.type](state, payload.payload);else return state;
      };

      funcReturn.reactotronKey = this.reactotronKey || (this.reactotronKey = "REDUCER_".concat(ReducerUUID++));
      funcReturn.initialState = this.initialState;
      funcReturn.autoMapToProps = this.buildStateToProps;
      return funcReturn;
    }
  }]);

  return ReducerBuilderProgress;
}();
export var ReducerBuilder =
/*#__PURE__*/
function () {
  function ReducerBuilder() {
    _classCallCheck(this, ReducerBuilder);
  }

  _createClass(ReducerBuilder, null, [{
    key: "newBuilder",
    value: function newBuilder(initialState, reactotronKey) {
      return new ReducerBuilderProgress(initialState, reactotronKey);
    }
  }, {
    key: "combineReducersAutoMaps",
    value: function combineReducersAutoMaps() {
      for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
        reducers[_key] = arguments[_key];
      }

      return function (state, action) {
        return reducers.reduce(function (finalObj, currentReducer) {
          Object.assign(finalObj, currentReducer(state, action));
          return finalObj;
        }, {});
      };
    }
  }]);

  return ReducerBuilder;
}();
ReducerBuilder.EVENT_ACTION_RESET_ALL_REDUCERS_TO_INITIAL_STATE = {
  type: "_REDUCER_EVENT_FULL_RESET",
  payload: undefined
};